import { useCallback, useEffect, useRef, useState } from "react";

export function useIsStuck<T extends HTMLElement>(enabled = true) {
  const [isStuck, setIsStuck] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  const ref = useCallback(
    (node: T | null) => {
      observerRef.current?.disconnect();
      observerRef.current = null;

      if (!node || !enabled) {
        setIsStuck(false);
        return;
      }

      const observer = new IntersectionObserver(([entry]) => setIsStuck(entry.intersectionRatio < 1), {
        threshold: [1],
      });
      observer.observe(node);
      observerRef.current = observer;
    },
    [enabled],
  );

  useEffect(() => {
    return () => observerRef.current?.disconnect();
  }, []);

  return { ref, isStuck };
}
